import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X, ArrowRight } from 'lucide-react';

const ProblemSolution = () => {
  const navigate = useNavigate();

  const without = [
    'No external consultants',
    'No £10,000–£25,000 review fees',
    'No lengthy consultancy reports',
    'No heavy internal resource cost',
  ];

  return (
    <section id="problem" className="py-24 md:py-32 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight mb-6 text-ink">
              Consultant-level governance reviews.<br className="hidden lg:block"/>
              <span className="highlighter mt-2 lg:mt-3 block w-fit">Without the consultants.</span>
            </h2>
            <p className="text-lg text-ink/60 mb-8 leading-relaxed font-medium">
              Traditional governance reviews often require expensive consultancy
              engagements, lengthy reports, and significant internal resources. GovernWell
              replaces all of it with a structured system you run yourself.
            </p>
            <div className="flex flex-col gap-3">
              {without.map((point, i) => (
                <div
                  key={i}
                  className="flex items-center gap-4 bg-white/80 border border-ink/5 rounded-xl px-4 py-3 shadow-saas-sm group hover:bg-white transition-colors"
                >
                  <div className="w-8 h-8 rounded-full bg-red-50 flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform">
                    <X className="w-4 h-4 text-red-500" />
                  </div>
                  <span className="font-semibold text-ink/80">{point}</span>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div
              id="solution"
              className="bg-white border border-ink/5 rounded-3xl p-8 md:p-10 shadow-saas relative overflow-hidden"
            >
              <div className="absolute top-0 right-0 w-64 h-64 bg-lime/10 blur-3xl rounded-full -translate-y-1/2 translate-x-1/3 pointer-events-none"></div>
              
              <h3 className="text-2xl md:text-3xl font-bold tracking-tight mb-6 text-ink relative z-10">
                A self-led governance review system.
              </h3>
              <p className="text-lg text-ink/60 mb-6 leading-relaxed relative z-10">
                GovernWell is a self-led governance review system that enables organisations to
                conduct consultant-level governance reviews internally.
              </p>
              <p className="text-lg text-ink/60 mb-10 leading-relaxed relative z-10">
                Assess governance effectiveness, identify governance gaps, prioritise
                improvements, and build a structured governance improvement roadmap — all
                through a proven step-by-step process.
              </p>
              
              <div className="bg-cream/50 border border-ink/5 rounded-2xl p-6 mb-10 relative z-10">
                <p className="text-xl md:text-2xl font-bold leading-tight tracking-tight text-ink">
                  Just a practical governance improvement system built by governance
                  professionals.
                </p>
              </div>

              <button
                onClick={() => navigate('/health-check')}
                className="bg-ink text-cream hover:bg-ink/90 rounded-full px-8 py-4 text-base font-semibold inline-flex items-center gap-2 transition-all active:scale-95 shadow-md hover:shadow-lg relative z-10"
              >
                Start Your Governance Assessment <ArrowRight className="w-5 h-5" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSolution;
